import api from './index'

class TxService {
	fetchDeposit(params) {
		return api.get('/deposit', { params })
	}
	fetchWithdraw(params) {
		return api.get('/withdraw', { params })
	}
	confirmTx(id, transfer = true) {
		return api.post(`/withdraw/${id}/confirm?transfer=${transfer}`)
	}
	rejectTx(id, remark = '') {
		return api.post(`/withdraw/${id}/reject`, {
			remark,
		})
	}
	redoTx(id) {
		return api.post(`/withdraw/${id}/redo`)
	}

	fixTx(data) {
		return api.post('/fix-tx', data)
	}
}

export default new TxService()
